module.exports = __webpack_public_path__ + "static/img/logo.a6c9aa8d.svg";